import { render, staticRenderFns } from "./newCount.vue?vue&type=template&id=2b7bdcfe&"
import script from "./newCount.vue?vue&type=script&lang=js&"
export * from "./newCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7bdcfe')) {
      api.createRecord('2b7bdcfe', component.options)
    } else {
      api.reload('2b7bdcfe', component.options)
    }
    module.hot.accept("./newCount.vue?vue&type=template&id=2b7bdcfe&", function () {
      api.rerender('2b7bdcfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/newCount.vue"
export default component.exports